import { JsonAPIDocument } from 'json-api-hooks';
import React, { FC } from 'react';

import './i18n';
import App from './app/components/App/App';
import { Globals } from './app/components/App/typescript';
import HeaderMain from './app/components/Header/HeaderMain';
import MainRoutes from './app/MainRoutes';

const Main: FC<{ globals: Globals; seed: JsonAPIDocument[]; snackbar?: string; badge?: string }> = ({
  badge,
  globals,
  seed,
  snackbar,
}) => {
  if (globals) {
    (window as any).GLOBALS = globals;
  }

  return (
    <App badge={badge} header={HeaderMain} seed={seed} snackbar={snackbar}>
      <MainRoutes />
    </App>
  );
};

export default Main;
